<!--
 * @Descripttion: formatter编辑器
 * @Author: zenghua.wang
 * @Date: 2021-09-22 17:39:59
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-25 10:14:20
-->
<template>
  <el-dialog v-if="show" class="formatter" :title="title" :visible.sync="show" width="80%" append-to-body
    destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false">
    <el-row>
      <el-col :span="18">
        <vue-javascript-editor :value="formatter" :readOnly="false" @js-save="onSave" @js-cancel="onCancel" />
      </el-col>
      <el-col :span="6">
        <vue-javascript-editor :placeholder="placeholder" :readOnly="true" :showTips="true" :showNumbers="false"
          :showBtns="false" />
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import vueJavascriptEditor from '@/dragComponents/components/vueJavascriptEditor.vue'

export default {
  name: 'javascript-formatter',
  components: {
    vueJavascriptEditor
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'javascript编辑器'
    },
    placeholder: {
      type: String
    },
    formatter: {
      type: [String, Number, Object, Array]
    },
    change: {
      type: Function
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    show(val) {
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSave(val) {
      this.$emit('change', val)
      this.visible = false
    },
    onCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.formatter {
  :deep(.el-dialog__body) {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
